import React, { useSyncExternalStore } from 'react';

import type { IAuthState } from '../../types';

export interface IAuthStateBridgeProps {
  subscribe: (cb: () => void) => () => void;
  getSnapshot: () => IAuthState;
}

/**
 * Bridge component that connects AuthClient state to React's external store system
 * Uses useSyncExternalStore to subscribe to authentication state changes
 */
export const AuthStateBridge: React.FC<IAuthStateBridgeProps> = ({ subscribe, getSnapshot }) => {
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return null;
};
